<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
              <span class="fonints">车牌号码</span>
              <el-input placeholder="请输入关键词" v-model="conditions.plate" clearable>
              </el-input>
            
            <span class="fonints">时间</span>
            <!-- <el-date-picker v-model="datetimerange" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker> -->
            <el-date-picker v-model="conditions.startTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间"
              @change="handleStartTimeChange"></el-date-picker>
              <span class="fonints">至</span>
            <el-date-picker v-model="conditions.endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间"
            :picker-options="{disabledDate}"></el-date-picker>
          
        </div>
        <div class="componentSty_content_title_flex_button">
          <button class="buttons" @click="selectlist">查询</button>
          <button class="buttons" @click="goback">返回</button>
        </div>
      </div>

      <div class="componentSty_content_table" style="border:none">
        <el-table :data="arrlist.list" style="width: 100%; height: 80%"  border height="80%">
          <el-table-column show-overflow-tooltip label="序号" type="index" width="50px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号码"> </el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" label="超速时间" prop="gmt_create">
            <template v-slot="res">
              {{ mydateFormat(res.row.gmtCreate, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="speed" label="时速(km/时)"></el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list && arrlist.list.length">
          <el-pagination :page-size="arrlist.pageSize" layout="total,prev, pager,next, jumper" :total="arrlist.total"
            :current-page="arrlist.pageNum" @current-change="getMemberlist">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import dayjs from "dayjs";
export default {
  data() {
    return {
      listitem: [{ name: "车辆管理" }, { name: "超速详情" }],
      timeout: null,
      conditions: {
        page: 1,
        limit: 20,
        plate: "",
        endTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        startTime: dayjs().subtract(6, 'hour').format('YYYY-MM-DD HH:mm:ss')
      },
      arrlist: [],
      datetimerange: [],
      startTime: null,
      endTime: null,
    };
  },
  components: {
    mTitle,
  },
  created() {
    this.conditions.plate = this.$route.query.plate;
    // this.datetimerange = [this.conditions.startTime, this.conditions.endTime]
    this.getMemberlist();
  },
  methods: {
    goback(){
      this.$router.go(-1)
    },
    handleStartTimeChange(value) {
      this.conditions.startTime=value
      this.conditions.endTime = null;
    },
    disabledDate(time) {
      if (!this.conditions.startTime) {
        return false;
      }
      const sixHoursLater = this.conditions.startTime.getTime() + 6 * 60 * 60 * 1000
      return time.getTime() > sixHoursLater || time.getTime() < this.conditions.startTime.getTime()
    },
    async getMemberlist(num) {
      this.conditions.startTime =this.conditions.startTime?dayjs(this.conditions.startTime).format('YYYY-MM-DD HH:mm:ss'):'';
      this.conditions.endTime = this.conditions.endTime?dayjs(this.conditions.endTime).format('YYYY-MM-DD HH:mm:ss'):'';
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/api/replenish/station/carMapSpeed",
        "post",
        this.conditions
      );
      if (!data || data.code != 0)
        return this.$message.error(data.msg||"获取数据失败");
      this.arrlist = data.data;
    },
    // itemparticulars(res) {
    //   window.sessionStorage.setItem("infoid", res.id);
    //   this.$router.push({ name: "newaddparticulars" });
    // },
    // sortchange(event) {
    //   if (event.prop) this.conditions.sidx = event.prop;
    //   if (event.order == "ascending") {
    //     this.conditions.sidx = event.prop;
    //     this.conditions.order = "asc";
    //   } else if (event.order == "descending") {
    //     this.conditions.sidx = event.prop;
    //     this.conditions.order = "desc";
    //   } else {
    //     this.conditions.sidx = "";
    //     this.conditions.order = "";
    //   }
    //   this.getMemberlist();
    // },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getMemberlist();
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
<style lang="scss">
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 220px !important;
}
</style>